module.exports = __webpack_public_path__ + "img/9791189143008.aa33e0cf.jpg";